<template>
  <div class="documentationHome">
    <div class="docNote">
      Click <a href="doc/StoryLink-User-Guide.pdf" download>here</a> to download the StoryLink User Guide
    </div>
  </div>
</template>

<script>

export default {
  name: "Documentation",
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.documentationHome {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: auto;
  text-align: center;
}

a:link {
  font-weight: bold;
  color:#4a4a4a;
  text-decoration: none;
}

a:visited {
  font-weight: bold;
  color:#4a4a4a;
  text-decoration: none;
}

.docNote{
  width: 50%;
  padding: .6rem;
  margin-bottom: .1rem;
  font-size: .8rem;
  text-align: left;
  background-color: rgb(230, 239, 242);
}

.installerTile{
  display: flex;
  flex-direction: column;  
  width: 12rem;
  height: auto;
  padding: .5rem;
  margin: .25rem;
  color:#777 !important;
  text-align: center;
  cursor: pointer;
  background-color: lightgray;
  border: grey;
  border-width: .5rem;
}

.osLogo{
  width: auto;
  height: 2rem;
  padding: 1rem;
}

</style>
